
import { errorStore } from '@/store'
import i18n from '@/commons/translations/i18n'
import { Component, Vue } from 'vue-property-decorator'
import ModalBox from '@/commons/components/modal-box/ModalBox.vue'
import ModalBoxErrorContent from '@/commons/components/modal-box/ModalBoxErrorContent.vue'

@Component({
    components: {
        ModalBox
    }
})
export default class ModalBoxError extends Vue {
    errorComponentInstance (): Vue {
        return new ModalBoxErrorContent(
            {
                name: 'errorModal',
                i18n: i18n,
                propsData: {
                    closeCallback: this.closeErrorModal
                }
            }
        )
    }

    get errorTitleTranslationKey (): string {
        return errorStore.getErrorTitleTranslationKey
    }

    closeErrorModal (): void {
        errorStore.clear()
    }
}
